import { render } from "./TestCodeMirror.vue?vue&type=template&id=6b24ec58"
import script from "./TestCodeMirror.vue?vue&type=script&lang=js"
export * from "./TestCodeMirror.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__